import * as React from 'react';

import { LucideIcon, XIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface FilterPillProps extends React.ComponentPropsWithoutRef<typeof Button> {
  icon: LucideIcon;
  title: string;
  text: string;
  onClose: () => void;
  isActive?: boolean;
}

export const FilterPill = ({
  icon: Icon,
  title,
  text,
  onClose,
  isActive = false,
  className,
  ref,
  ...rest
}: FilterPillProps & { ref?: React.Ref<HTMLButtonElement> }) => {
  return (
    <Button
      ref={ref}
      variant="secondary"
      size="sm"
      className={cn(
        'h-auto min-h-6 min-w-0 justify-start gap-2 py-1.5 font-normal text-foreground hover:bg-surface-button-secondary/80 [&_svg]:text-foreground-muted',
        isActive && 'ring-2 ring-primary ring-offset-1',
        className
      )}
      {...rest}
    >
      <Icon />

      <div className="truncate text-sm">
        <span className="font-semibold">{title}: </span>
        <span className="font-normal">{text}</span>
      </div>

      <Button
        variant="ghost-neutral"
        size="icon-xss"
        onClick={(event) => {
          event.stopPropagation();
          onClose();
        }}
      >
        <XIcon />
      </Button>
    </Button>
  );
};
